// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meeting-summary {
  padding: var(--spacing-lg);
  background: var(--color-bg-secondary);
  border-radius: var(--radius-lg);
  margin-top: var(--spacing-xl);
  border: 1px solid var(--color-border);
  position: relative;
}

.meeting-summary::before {
  content: 'MEETING HISTORY';
  position: absolute;
  top: -10px;
  left: var(--spacing-lg);
  background: var(--color-card-bg);
  padding: 0 var(--spacing-sm);
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  font-weight: 600;
  letter-spacing: 0.08em;
}

.meeting-summary h4 {
  font-size: var(--font-size-lg);
  color: var(--color-secondary);
  margin-bottom: var(--spacing-md);
  font-weight: 600;
}

.meeting-selector {
  display: flex;
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-lg);
  overflow-x: auto;
  padding-bottom: var(--spacing-sm);
  scrollbar-width: thin;
  scrollbar-color: var(--color-gray-300) var(--color-gray-100);
}

.meeting-selector::-webkit-scrollbar {
  height: 6px;
}

.meeting-selector::-webkit-scrollbar-track {
  background: var(--color-gray-100);
  border-radius: var(--radius-full);
}

.meeting-selector::-webkit-scrollbar-thumb {
  background: var(--color-gray-300);
  border-radius: var(--radius-full);
}

.meeting-selector::-webkit-scrollbar-thumb:hover {
  background: var(--color-gray-400);
}

.meeting-date-btn {
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--color-card-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
  white-space: nowrap;
  cursor: pointer;
  transition: all var(--transition-base);
  font-weight: 500;
  position: relative;
}

.meeting-date-btn::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  width: 80%;
  height: 2px;
  background: var(--color-primary);
  transition: transform var(--transition-base);
}

.meeting-date-btn:hover {
  background: var(--color-hover-bg);
  border-color: var(--color-border-hover);
  transform: translateY(-1px);
}

.meeting-date-btn:hover::after {
  transform: translateX(-50%) scaleX(1);
}

.meeting-date-btn.active {
  background: var(--color-secondary-dark);
  color: white;
  border-color: var(--color-secondary-dark);
  box-shadow: var(--shadow-sm);
}

.meeting-date-btn.active::after {
  transform: translateX(-50%) scaleX(1);
  background: var(--color-primary);
}

.meeting-buttons {
  display: flex;
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-lg);
  border-bottom: 1px solid var(--color-border);
  padding-bottom: var(--spacing-md);
}

.meeting-button {
  padding: var(--spacing-sm) var(--spacing-lg);
  background: var(--color-card-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  color: var(--color-secondary);
  font-size: var(--font-size-sm);
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-base);
  position: relative;
  overflow: hidden;
}

.meeting-button::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--color-primary);
  transform: translateY(100%);
  transition: transform var(--transition-base);
}

.meeting-button:hover {
  background: var(--color-hover-bg);
  border-color: var(--color-border-hover);
}

.meeting-button:hover::before {
  transform: translateY(0);
}

.meeting-button.active {
  background: var(--color-primary);
  color: white;
  border-color: var(--color-primary);
  box-shadow: var(--shadow-sm);
}

.meeting-button.active::before {
  transform: translateY(0);
  background: var(--color-primary-dark);
}

.meeting-content {
  background: var(--color-card-bg);
  padding: var(--spacing-lg);
  border-radius: var(--radius-md);
  min-height: 140px;
  color: var(--color-text-primary);
  line-height: 1.8;
  border: 1px solid var(--color-border);
  animation: fadeIn var(--transition-base) ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.action-item {
  display: flex;
  align-items: flex-start;
  padding: var(--spacing-md) 0;
  border-bottom: 1px solid var(--color-border);
  transition: all var(--transition-base);
  cursor: pointer;
}

.action-item:last-child {
  border-bottom: none;
}

.action-item:hover {
  background: var(--color-hover-bg);
  margin: 0 calc(-1 * var(--spacing-md));
  padding-left: var(--spacing-md);
  padding-right: var(--spacing-md);
  border-radius: var(--radius-md);
}

.action-checkbox {
  width: 20px;
  height: 20px;
  margin-right: var(--spacing-md);
  margin-top: 2px;
  cursor: pointer;
  accent-color: var(--color-primary);
  flex-shrink: 0;
  position: relative;
}

.action-checkbox:checked {
  animation: checkPulse var(--transition-base) ease-out;
}

@keyframes checkPulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

.action-text {
  flex: 1 1;
  color: var(--color-text-primary);
  font-size: var(--font-size-base);
  line-height: 1.6;
  transition: all var(--transition-base);
}

.action-text.completed {
  text-decoration: line-through;
  color: var(--color-gray-400);
  opacity: 0.7;
}

.action-item:hover .action-text {
  color: var(--color-secondary);
}

.action-item:hover .action-text.completed {
  color: var(--color-gray-500);
}

.action-meta {
  font-size: var(--font-size-xs);
  color: var(--color-gray-500);
  margin-left: var(--spacing-sm);
  font-weight: 500;
}

.no-actions {
  color: var(--color-gray-500);
  font-style: italic;
  text-align: center;
  padding: var(--spacing-xl);
}`, "",{"version":3,"sources":["webpack://./src/components/MeetingSummary.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,qCAAqC;EACrC,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gCAAgC;EAChC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,4BAA4B;EAC5B,4CAA4C;EAC5C,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,SAAO;EACP,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B","sourcesContent":[".meeting-summary {\n  padding: var(--spacing-lg);\n  background: var(--color-bg-secondary);\n  border-radius: var(--radius-lg);\n  margin-top: var(--spacing-xl);\n  border: 1px solid var(--color-border);\n  position: relative;\n}\n\n.meeting-summary::before {\n  content: 'MEETING HISTORY';\n  position: absolute;\n  top: -10px;\n  left: var(--spacing-lg);\n  background: var(--color-card-bg);\n  padding: 0 var(--spacing-sm);\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n  font-weight: 600;\n  letter-spacing: 0.08em;\n}\n\n.meeting-summary h4 {\n  font-size: var(--font-size-lg);\n  color: var(--color-secondary);\n  margin-bottom: var(--spacing-md);\n  font-weight: 600;\n}\n\n.meeting-selector {\n  display: flex;\n  gap: var(--spacing-sm);\n  margin-bottom: var(--spacing-lg);\n  overflow-x: auto;\n  padding-bottom: var(--spacing-sm);\n  scrollbar-width: thin;\n  scrollbar-color: var(--color-gray-300) var(--color-gray-100);\n}\n\n.meeting-selector::-webkit-scrollbar {\n  height: 6px;\n}\n\n.meeting-selector::-webkit-scrollbar-track {\n  background: var(--color-gray-100);\n  border-radius: var(--radius-full);\n}\n\n.meeting-selector::-webkit-scrollbar-thumb {\n  background: var(--color-gray-300);\n  border-radius: var(--radius-full);\n}\n\n.meeting-selector::-webkit-scrollbar-thumb:hover {\n  background: var(--color-gray-400);\n}\n\n.meeting-date-btn {\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--color-card-bg);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-sm);\n  color: var(--color-text-primary);\n  font-size: var(--font-size-sm);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all var(--transition-base);\n  font-weight: 500;\n  position: relative;\n}\n\n.meeting-date-btn::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 50%;\n  transform: translateX(-50%) scaleX(0);\n  width: 80%;\n  height: 2px;\n  background: var(--color-primary);\n  transition: transform var(--transition-base);\n}\n\n.meeting-date-btn:hover {\n  background: var(--color-hover-bg);\n  border-color: var(--color-border-hover);\n  transform: translateY(-1px);\n}\n\n.meeting-date-btn:hover::after {\n  transform: translateX(-50%) scaleX(1);\n}\n\n.meeting-date-btn.active {\n  background: var(--color-secondary-dark);\n  color: white;\n  border-color: var(--color-secondary-dark);\n  box-shadow: var(--shadow-sm);\n}\n\n.meeting-date-btn.active::after {\n  transform: translateX(-50%) scaleX(1);\n  background: var(--color-primary);\n}\n\n.meeting-buttons {\n  display: flex;\n  gap: var(--spacing-sm);\n  margin-bottom: var(--spacing-lg);\n  border-bottom: 1px solid var(--color-border);\n  padding-bottom: var(--spacing-md);\n}\n\n.meeting-button {\n  padding: var(--spacing-sm) var(--spacing-lg);\n  background: var(--color-card-bg);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-sm);\n  color: var(--color-secondary);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-base);\n  position: relative;\n  overflow: hidden;\n}\n\n.meeting-button::before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--color-primary);\n  transform: translateY(100%);\n  transition: transform var(--transition-base);\n}\n\n.meeting-button:hover {\n  background: var(--color-hover-bg);\n  border-color: var(--color-border-hover);\n}\n\n.meeting-button:hover::before {\n  transform: translateY(0);\n}\n\n.meeting-button.active {\n  background: var(--color-primary);\n  color: white;\n  border-color: var(--color-primary);\n  box-shadow: var(--shadow-sm);\n}\n\n.meeting-button.active::before {\n  transform: translateY(0);\n  background: var(--color-primary-dark);\n}\n\n.meeting-content {\n  background: var(--color-card-bg);\n  padding: var(--spacing-lg);\n  border-radius: var(--radius-md);\n  min-height: 140px;\n  color: var(--color-text-primary);\n  line-height: 1.8;\n  border: 1px solid var(--color-border);\n  animation: fadeIn var(--transition-base) ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.action-item {\n  display: flex;\n  align-items: flex-start;\n  padding: var(--spacing-md) 0;\n  border-bottom: 1px solid var(--color-border);\n  transition: all var(--transition-base);\n  cursor: pointer;\n}\n\n.action-item:last-child {\n  border-bottom: none;\n}\n\n.action-item:hover {\n  background: var(--color-hover-bg);\n  margin: 0 calc(-1 * var(--spacing-md));\n  padding-left: var(--spacing-md);\n  padding-right: var(--spacing-md);\n  border-radius: var(--radius-md);\n}\n\n.action-checkbox {\n  width: 20px;\n  height: 20px;\n  margin-right: var(--spacing-md);\n  margin-top: 2px;\n  cursor: pointer;\n  accent-color: var(--color-primary);\n  flex-shrink: 0;\n  position: relative;\n}\n\n.action-checkbox:checked {\n  animation: checkPulse var(--transition-base) ease-out;\n}\n\n@keyframes checkPulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.2); }\n  100% { transform: scale(1); }\n}\n\n.action-text {\n  flex: 1;\n  color: var(--color-text-primary);\n  font-size: var(--font-size-base);\n  line-height: 1.6;\n  transition: all var(--transition-base);\n}\n\n.action-text.completed {\n  text-decoration: line-through;\n  color: var(--color-gray-400);\n  opacity: 0.7;\n}\n\n.action-item:hover .action-text {\n  color: var(--color-secondary);\n}\n\n.action-item:hover .action-text.completed {\n  color: var(--color-gray-500);\n}\n\n.action-meta {\n  font-size: var(--font-size-xs);\n  color: var(--color-gray-500);\n  margin-left: var(--spacing-sm);\n  font-weight: 500;\n}\n\n.no-actions {\n  color: var(--color-gray-500);\n  font-style: italic;\n  text-align: center;\n  padding: var(--spacing-xl);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
